/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bookmark-add': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6.01 2c-1.096 0-2 .903-2 1.998L4 22l8-3 8 3V4c0-1.093-.907-2-2-2H6.01zm0 2H18v15.113l-6-2.25-5.998 2.25L6.01 4z" _fill="currentColor" fill-rule="nonzero"/>'
  }
})
